<template>
<div class="container mt-5">
    <div class="row">
        <div class="col-md-12">
            <h3 class="display-4">My Experience</h3>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-6">
            <h4>My Work Experience</h4>
            <hr />
            <div class="row mt-3" v-for="(item,index) in resdata.work" :key="index">
                <div class="col-md-3 col-4">
                    <img :src="item.img" class="logo" />
                </div>
                <div class="col-md-9 col-8 p-4">
                    <b>{{item.name}}</b>
                    <br />
                    {{item.role}}
                    <br />
                    ({{item.duration}})
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <h4>Community Experience</h4>
            <hr />
            <div class="row mt-3" v-for="(item,index) in resdata.community" :key="index">
                <div class="col-md-3 col-4">
                    <img :src="item.img" class="logo" />
                </div>
                <div class="col-md-9 col-8 p-4">
                    <b>{{item.name}}</b>
                    <br />
                    {{item.role}}
                    <br />
                    ({{item.duration}})
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import resdata from "@/assets/data/workexperience.json";
export default {
    name: "WorkExperience",
    data: () => ({
        resdata
    })
};
</script>

<style>
.logo {
    border-radius: 50%;
    border: 2px solid #e0e0e0;
    margin: 5px 5px;
    width: 110px;
    height: 110px;
}
</style>
